'use client'
import { useEffect } from 'react'

export default function TidioChat() {
  useEffect(() => {
    if (document.getElementById('tidio-chat')) return

    const script = document.createElement('script')
    script.src = "//code.tidio.co/kswvggtjhvlprof8mvcorybiazqpqyvn.js"
    script.async = true
    script.id = "tidio-chat"
    document.body.appendChild(script)
  }, [])

  return null
}

